import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../treasuryContractBooking.config";
import { BOM } from "../../../services/definedMethod";

const AddTrade = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [securityMasterOptions, setSecurityMasterOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [counterpartyOptions, setCounterpartyOptions] = useState([]);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        productId:        values.productId,
        securityMasterId: values.securityMasterId,
        portfolioId:      values.portfolioId,
        counterpartyId:   values.counterpartyId,
        tradeDate:        values.tradeDate?.format("YYYY-MM-DD"),
        settlementDate:   values.settlementDate?.format("YYYY-MM-DD"),
        maturityDate:     values.maturityDate?.format("YYYY-MM-DD"),
        faceValue:        values.faceValue,
        tradePrice:       values.tradePrice,
        considerationAmount: values.considerationAmount,
      };

      // await BOM.SendReq(apiConfig.createTrade, payload);
      console.log("AddTrade payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Trade created successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to create trade.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.manageTrade}>
      <TopContent pageTitle={labelConfig.trade} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}>
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>Create Trade</h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              {/* Product & Security Master */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Product <Tooltip title="The product this trade is booked against."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="productId"
                    rules={[{ required: true, message: "Product is required" }]}
                  >
                    <Select style={{ height: 44 }} suffixIcon={<ChevronDown color="#667085" />} options={productOptions} placeholder="Select Product" showSearch optionFilterProp="label" />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Security Master <Tooltip title="The underlying security instrument for this trade."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="securityMasterId"
                    rules={[{ required: true, message: "Security Master is required" }]}
                  >
                    <Select style={{ height: 44 }} suffixIcon={<ChevronDown color="#667085" />} options={securityMasterOptions} placeholder="Select Security Master" showSearch optionFilterProp="label" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Portfolio & Counterparty */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Portfolio <Tooltip title="The portfolio to which this trade is assigned."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="portfolioId"
                    rules={[{ required: true, message: "Portfolio is required" }]}
                  >
                    <Select style={{ height: 44 }} suffixIcon={<ChevronDown color="#667085" />} options={portfolioOptions} placeholder="Select Portfolio" showSearch optionFilterProp="label" />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Counterparty <Tooltip title="The counterparty on the other side of this trade."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="counterpartyId"
                    rules={[{ required: true, message: "Counterparty is required" }]}
                  >
                    <Select style={{ height: 44 }} suffixIcon={<ChevronDown color="#667085" />} options={counterpartyOptions} placeholder="Select Counterparty" showSearch optionFilterProp="label" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Trade Date & Settlement Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Trade Date <Tooltip title="The date on which the trade is executed."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="tradeDate"
                    rules={[{ required: true, message: "Trade date is required" }]}
                  >
                    <DatePicker style={{ width: "100%", height: 44 }} format="YYYY-MM-DD" placeholder="YYYY-MM-DD" />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Settlement Date <Tooltip title="The date on which the trade settles."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="settlementDate"
                    rules={[{ required: true, message: "Settlement date is required" }]}
                  >
                    <DatePicker style={{ width: "100%", height: 44 }} format="YYYY-MM-DD" placeholder="YYYY-MM-DD" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Maturity Date & Face Value */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Maturity Date <Tooltip title="The date on which the instrument matures."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="maturityDate"
                    rules={[{ required: true, message: "Maturity date is required" }]}
                  >
                    <DatePicker style={{ width: "100%", height: 44 }} format="YYYY-MM-DD" placeholder="YYYY-MM-DD" />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Face Value <Tooltip title="The nominal / par value of the trade."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="faceValue"
                    rules={[
                      { required: true, message: "Face value is required" },
                      { type: "number", min: 1, message: "Face value must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 50,000,000.00"
                      formatter={(v) => (v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")}
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Trade Price & Consideration Amount */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Trade Price <Tooltip title="The price per 100 face value at which the trade is executed."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="tradePrice"
                    rules={[
                      { required: true, message: "Trade price is required" },
                      { type: "number", min: 0, max: 100, message: "Trade price must be between 0 and 100" },
                    ]}
                  >
                    <InputNumber style={{ width: "100%", height: 44 }} placeholder="e.g. 98.50" precision={2} min={0} max={100} />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Consideration Amount <Tooltip title="The actual cash amount exchanged — typically Face Value × (Trade Price / 100)."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="considerationAmount"
                    rules={[
                      { required: true, message: "Consideration amount is required" },
                      { type: "number", min: 1, message: "Consideration amount must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 49,250,000.00"
                      formatter={(v) => (v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")}
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Divider */}
              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              {/* Action Buttons */}
              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #D0D5DD", background: "#fff", color: "#344054", fontWeight: 600, fontSize: 14, cursor: "pointer", marginRight: 12 }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #BA24D5", background: "#BA24D5", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}
                  >
                    Submit
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(AddTrade);